import React from 'react'
import { Box } from 'components/layout/Box/Box'
import styles from './Question.module.scss'

export const Question = ({ title, description, index, isWordDoc }) => {
  if (isWordDoc) {
    const getDescription = (line, index) => (
      <div key={index}>
        {index ? '- ' : ''}
        {line}
      </div>
    )

    return (
      <Box className={styles.question}>
        <Box className={styles.text} direction="column">
          <p className={styles.title}>{`${index + 1}. ${title}`}</p>
          <div className={styles.description}>
            {description.split('- ').map(getDescription)}
          </div>
        </Box>
      </Box>
    )
  }

  return (
    <Box className={styles.question}>
      <div className={styles.order}>{index + 1}</div>
      <Box className={styles.text} direction="column">
        <div className={styles.title}>{title}</div>
        <p className={styles.description}>{description}</p>
      </Box>
    </Box>
  )
}
